// Les tokens DartsHub complets ne partent que vers un site de la plateforme ou le domaine
// d'une ligue/d'un comité, vérifié par le backend (cf. auth/trusted_redirects.py) : un
// lien auth.dartshub.fr/login?redirect=<site tiers> livrait sinon la session.
// Refus par défaut en cas d'erreur.
import axios from 'axios';
import { backend_url } from '@/config/config';

const cache = new Map<string, Promise<boolean>>();

export function isTrustedRedirect(url: string | null | undefined): Promise<boolean> {
  if (!url) return Promise.resolve(false);
  if (!cache.has(url)) {
    cache.set(url, axios.get(`${backend_url}/auth/redirect-check`, { params: { url } })
      .then(({ data }) => data?.trusted === true)
      .catch(() => false));
  }
  return cache.get(url)!;
}
